import type { FC, ReactNode } from 'react'
import type { Product } from '@/types'

import { cms } from '@/lib/cms'
import { coverStyle } from '@/lib/cover'
import { cn } from '@/lib/utils'

interface ProductTileProps {
    product: Product
    className?: string
    showTag?: boolean
}

/*
 * A square thumbnail of a product's cover: its colors and kanji. Used on the
 * hero wheel, in the panels and in the bag. Round it with className.
 */
const ProductTile: FC<ProductTileProps> = ({ product, className, showTag = false }): ReactNode => {
    const { cover } = product

    return (
        <span aria-hidden className={cn('kuro-cover relative block overflow-hidden', className)} style={coverStyle(cover)}>
            <span className='kuro-cover-sun right-[-18cqw] top-[-14cqw] size-[70cqw]' />
            <span className='kuro-cover-gloss' />

            <span
                {...cms('products', product.id, 'cover_kanji')}
                lang='ja'
                className={cn(
                    'absolute inset-0 grid place-items-center font-jp text-[54cqw] font-semibold leading-none',
                    showTag && 'pb-[16cqw] text-[48cqw]'
                )}
            >
                {cover.kanji}
            </span>

            {showTag && (
                <span {...cms('products', product.id, 'tag')} className='absolute inset-x-0 bottom-[11cqw] text-center text-[10cqw] font-bold uppercase leading-none tracking-[0.1em]'>
                    {product.tag}
                </span>
            )}
        </span>
    )
}

export default ProductTile
